export default __webpack_public_path__ + "static/media/BeyondBlue.95e251d8.png";